import { Radio, Select, Space, Typography } from 'antd'
import React, { useEffect, useState } from 'react'

const DropDown = (props) => {
    const { title, name, onChange, data, options } = props

    const [open, setOpen] = useState(false);
    const [value, setValue] = useState();
    const onChangeRadio = (e) => {
        const { name, value } = e.target
        setValue(value);
        onChange({ [name]: value })
        setOpen(false)
    }
    useEffect(() => {
        setValue(data[name] ? data[name] : 'All')
    }, [data])

    return (
        <Space direction="vertical" >
            <Typography.Title level={5} style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>{title}</Typography.Title>
            <Select
                // defaultValue="Yiminghe"
                // style={{ width: 220, height: '100%' }}
                open={open}
                className='dropdown-select'
                onClick={() => setOpen(!open)}
                // onBlur={() => open === true ? setOpen(!open) : false}
                onBlur={() => setOpen(false)}
                value={value}
                // options={options}
                dropdownRender={() => (
                    <Space
                        className='custom_select'
                        onMouseDown={e => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        direction="vertical" style={{ width: '100%', padding: 20 }} >
                        {/* {options} */}
                        <Radio.Group onChange={onChangeRadio} value={value} name={name}>

                            <Space direction="vertical">
                                <Radio value='All' defaultChecked> All</Radio>
                                {options.map((option, i) => (
                                    <Radio key={i} value={option.value}>{option.label} </Radio>
                                ))}

                            </Space>
                        </Radio.Group>
                        {/* <Button type="primary" onClick={() => onClick()} style={{ width: '100%' }}>
                            Apply
                        </Button> */}
                    </Space>)}
            />
        </Space>
    )
}

export default DropDown